export default [
    {
        path: '/print-invoice',
        name: 'print_invoice',
        component: () => import('@src/accounting/print-invoice/print-document'),
        meta: {
            title: 'Rechnung drucken',
            role: 'ROLE_PRINT_INVOICE',
        },
    },
];
